module.exports = __webpack_public_path__ + "static/media/map_pin_stop.7d07cd28.svg";